import { getSubscriptionModules } from '@/api/queries/getSubscriptionModules';
import { getSubscriptionStatus } from '@/api/queries/getSubscriptionStatus';
import getUserActiveModulesSubscriptions from '@/api/queries/getUserActiveModulesSubscriptions';
import { useQuery } from '@tanstack/react-query';

export const useSubscriptionQueries = () => {
  const { data: subscriptionStatus, isLoading: isSubscriptionStatusLoading } = useQuery({
    queryKey: ['subscriptionStatus'],
    queryFn: getSubscriptionStatus,
    refetchInterval: 1000 * 60 * 5, // 5 minutes
  });

  return { subscriptionStatus, isSubscriptionStatusLoading };
};

export const useUserActiveModulesSubscriptions = () => {
  const {
    data: userActiveModulesSubscriptions,
    isLoading: isUserActiveModulesSubscriptionsLoading,
  } = useQuery({
    queryKey: ['userActiveModulesSubscriptions'],
    queryFn: getUserActiveModulesSubscriptions,
  });

  return { userActiveModulesSubscriptions, isUserActiveModulesSubscriptionsLoading };
};

export const useGetSubscriptionModules = () => {
  const { data: subscriptionModules, isLoading: isSubscriptionModulesLoading } = useQuery({
    queryKey: ['subscriptionModules'],
    queryFn: getSubscriptionModules,
  });

  return { subscriptionModules, isSubscriptionModulesLoading };
};

export default useSubscriptionQueries;
